import { Component, Element, h, Prop, Listen } from '@stencil/core';
import { PageNode } from 'interfaces/PageNode';

@Component({
    tag: 'kdx-nav-basic',
    styleUrl: 'kdx-nav-basic.scss',
    shadow: false
})
export class AppNav {

    @Element() root: HTMLElement;

    @Prop() pageNodes: string = '';
    
    pageNodeArray: Array<PageNode> = [];
    mobileUtilNav: string;
    
    @Listen('resize', {target: 'window'})
    resizeHandler() {
        if (window.innerWidth >= 992) {
            this.bindDesktop();
        }
        else {
            this.bindMobile();
        }
    }

    componentWillLoad() {
        
        if (this.pageNodes !== '') {
            this.pageNodeArray = JSON.parse(this.pageNodes);
        }
        
    }
    
    componentDidLoad() {
        // this.mobileNavToggle();
        this.sortHeaderForMobile();
        this.toggleMobileNav();
        this.toggleMobileSearch();

        if (window.innerWidth >= 992) {
            this.bindDesktop();
        }
        else {
            this.bindMobile();
        }

        // if keyboard goes out of menu, close all
        document.onkeydown = () => {
            if (document.activeElement.classList.contains('js-login-btn')) {
                const nodes = this.root.querySelectorAll('.basic-nav__node.opened');

                if (nodes && nodes.length) {
                    nodes.forEach((node) => {
                        node.classList.remove('opened');
                    });
                }
                document.querySelector('body').classList.remove('menu-open');
            }
        };
    }

    bindDesktop() {
        const parentNodes = this.root.querySelectorAll('.basic-nav__node');
        const parentLinks = this.root.querySelectorAll('.basic-nav__parent_link');
        
        if (parentNodes) {
            parentNodes.forEach((parentNode) => {
                parentNode.addEventListener('focusin', this.openSubmenu.bind(this));
                parentNode.addEventListener('mouseenter', this.openSubmenu.bind(this));
                parentNode.addEventListener('mouseleave', this.closeSubmenu.bind(this));
            });
        }
        if (parentLinks) {
            parentLinks.forEach((parentLink) => {
                parentLink.addEventListener('focusin', this.openSubmenu.bind(this));
            });
        }
    }

    bindMobile() {
        const parentLinks = this.root.querySelectorAll('.basic-nav__parent-link');

        if (parentLinks) {
            parentLinks.forEach((parentLink) => {
                parentLink.addEventListener('click', this.openSubmenu.bind(this));
            });
        }
    }

    sortHeaderForMobile() {
        // on mobile everything in header needs to move around to match design, so we are using JS to copy items

        // copy keylink btn
        const keylinkBtn = document.querySelector('.js-keylink-btn')?.cloneNode(true);
        const keylinkBtnMobileHtml = document.querySelector('.header-bar-actions .mobile-keylink-btn') as HTMLElement;
        if (keylinkBtn && keylinkBtnMobileHtml) {
            keylinkBtnMobileHtml.appendChild(keylinkBtn);
        }
        
        // copy login btn
        const loginBtn = document.querySelector('.js-login-btn')?.cloneNode(true);        
        const loginBtnMobileHtml = document.querySelector('.header-bar-actions .mobile-login-btn') as HTMLElement;
        if (loginBtn && loginBtnMobileHtml) {
            loginBtnMobileHtml.appendChild(loginBtn);
        }

        // copy utility nav
        const utilityBar = document.querySelector('.site-header-util')?.cloneNode(true);
        const mobileUtilityHtml = document.querySelector('.mobile-utility-nav') as HTMLElement;
        if (utilityBar && mobileUtilityHtml) {
            mobileUtilityHtml.appendChild(utilityBar);
        }
        
    }   

    openSubmenu(e: any) {                     
        const openNodes = this.root.querySelectorAll('.basic-nav__node.opened');

        // close any open menus except clicked one
        if (openNodes) {
            openNodes.forEach((node) => {
                if (node != e.currentTarget.closest('.basic-nav__node')) {
                    node.closest('.basic-nav__node').classList.remove('opened');
                    node.querySelector('kdx-icon').setAttribute('icon', 'plus');
                    document.querySelector('body').classList.remove('menu-open');
                }
            });
        }

        if (!e.currentTarget.closest('.basic-nav__node').classList.contains('opened')) {            
            e.currentTarget.closest('.basic-nav__node').classList.toggle('opened');            
            document.querySelector('body').classList.add('menu-open');
        }              
    }
    
    closeSubmenu(e: any) {        
        e.currentTarget.closest('.basic-nav__node').classList.remove('opened');        
        document.querySelector('body').classList.remove('menu-open');
    }

    mobileNavToggle(e) {
        
        e.preventDefault();       

        if (!e.currentTarget.closest('.basic-nav__node').classList.contains('opened')) {
            e.currentTarget.closest('.basic-nav__node').querySelector('kdx-icon').setAttribute('icon', 'minus');
        }
        else {
            e.currentTarget.closest('.basic-nav__node').querySelector('kdx-icon').setAttribute('icon', 'plus');
        }
        e.currentTarget.classList.add('toggle-current');
        this.closeAllMobileToggles();
        // const node: any = e.currentTarget.parentNode.parentNode;
        const node = e.currentTarget.parentElement.parentElement as HTMLElement;
        node.classList.toggle('opened');
        e.currentTarget.classList.remove('toggle-current');
        
    }

    closeAllMobileToggles() {
        const toggles = this.root.querySelectorAll('.basic-nav__toggle');

        toggles.forEach((toggle) => {
            if (!toggle.classList.contains('toggle-current')) {
                const node: any = toggle.parentNode.parentNode;
                node.classList.remove('opened');
                node.querySelector('kdx-icon').setAttribute('icon', 'plus');
            }
        });
    }     

    toggleMobileNav() {        
        const toggle: HTMLButtonElement = document.querySelector('.mobile-nav-toggle');
        const siteHeaderMain: HTMLElement = document.querySelector('.site-header-main');
        const nav: HTMLElement = document.querySelector('.basic-nav');

        if (!toggle || !nav) {
            return;
        }

        toggle.addEventListener('click', (e)=> {            
            e.preventDefault();
            this.closeMobileSearch();
            siteHeaderMain.classList.toggle('opened');
            nav.classList.toggle('opened');
            nav.classList.toggle('closed');
            toggle.classList.toggle('opened');
        });
    }    

    toggleMobileSearch() {
        const toggle: HTMLElement = document.querySelector('.mobile-search-toggle');
        const search: HTMLElement = document.querySelector('.site-header-basic__search');

        if (!toggle || !search) {
            return;
        }

        toggle.onclick = (e) => {
            e.preventDefault();
            this.closeMobileNav();
            search.classList.toggle('opened');
            search.classList.toggle('closed');
            toggle.classList.toggle('opened');
        };
    }

    closeMobileNav() {
        const toggle: HTMLElement = document.querySelector('.mobile-nav-toggle');
        const nav: HTMLElement = document.querySelector('.site-header-basic__main-nav');

        if (!toggle || !nav) {
            return;
        }

        toggle.classList.remove('opened');
        nav.classList.remove('opened');
        nav.classList.add('closed');
    }

    closeMobileSearch() {
        const toggle: HTMLElement = document.querySelector('.mobile-search-toggle');
        const search: HTMLElement = document.querySelector('.site-header-basic__search');

        if (!toggle || !search) {
            return;
        }

        toggle.classList.remove('opened');
        search.classList.remove('opened');
    }

    render() {
        return (
            <nav class="basic-nav">
                {Boolean(this.mobileUtilNav) && (
                    <div class="basic-nav__mobile-util-nav" innerHTML={this.mobileUtilNav}></div>
                )}

                {this.pageNodeArray.map((node) => (
                    <div class="basic-nav__node">
                        <div class="basic-nav__parent">
                            <a href={node.UrlName} 
                                aria-label={node.Title} 
                                class="basic-nav__parent-link"                                 
                            >
                                { node.Title }
                            </a>
                            {Boolean(node.Nodes && node.Nodes.length) && (
                                <div class="basic-nav__toggle" tabindex="0" onClick={this.mobileNavToggle.bind(this)} onKeyPress={this.mobileNavToggle.bind(this)}>
                                    <kdx-icon icon="plus"></kdx-icon>
                                </div>
                            )}

                        </div>

                        {Boolean(node.Nodes && node.Nodes.length) && (
                            <div class="basic-nav__children">
                                {node.Nodes.map((child) => (
                                    <div>
                                        <a href={child.UrlName} aria-label={child.Title} class="basic-nav__child-link">
                                            { child.Title }
                                        </a>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
                
            </nav>
        );
    }
}
